import { graphql } from 'react-relay';

export const tagFragment = graphql`
    fragment tagFragment on Tag {
        id
    }
`;
